import * as u from './utils';

export default () => {
    const container = document.querySelectorAll('.pipeskirts');

    if (!container) {
        return;
    }

    for (const el of container) {
        const image = el.querySelector('.pipeskirts__image img');
        const shapeButtons = el.querySelectorAll('.pipeskirts__shape');
        const finishButtons = el.querySelectorAll('.pipeskirts__finish');
        let activeShape = false;
        let activeFinish = false;

        const options = JSON.parse(el.dataset.options);

        if (!options) {
            return;
        }

        const activateOption = () => {
            for (const option of options) {
                if (option['shape'] === activeShape && option['finish'] === activeFinish) {
                    image.setAttribute('src', option['image']);
                    break;
                }
            }
        };

        const updateInactiveOptions = () => {
            u.addClass(finishButtons, 'inactive');
            for (const option of options) {
                if (option['shape'] === activeShape) {
                    u.removeClass(
                        document.querySelector(`.pipeskirts__finish[data-finish="${option['finish']}"]`),
                        'inactive'
                    );
                }
            }

            u.addClass(shapeButtons, 'inactive');
            for (const option of options) {
                if (option['finish'] === activeFinish) {
                    u.removeClass(
                        document.querySelector(`.pipeskirts__shape[data-shape="${option['shape']}"]`),
                        'inactive'
                    );
                }
            }
        };

        activeShape = options[0]['shape'];
        activeFinish = parseInt(options[0]['finish'], 10);
        u.addClass(el.querySelector(`.pipeskirts__shape[data-shape="${activeShape}"]`), 'is-active');
        u.addClass(el.querySelector(`.pipeskirts__finish[data-finish="${activeFinish}"]`), 'is-active');

        updateInactiveOptions();
        activateOption();

        for (const button of shapeButtons) {
            // eslint-disable-next-line no-loop-func
            button.addEventListener('click', (e) => {
                if (u.hasClass(e.currentTarget, 'inactive')) {
                    return;
                }

                u.removeClass(shapeButtons, 'is-active');
                activeShape = e.currentTarget.dataset.shape;
                u.addClass(el.querySelector(`.pipeskirts__shape[data-shape="${activeShape}"]`), 'is-active');

                updateInactiveOptions();
                activateOption();
            });
        }

        for (const button of finishButtons) {
            // eslint-disable-next-line no-loop-func
            button.addEventListener('click', (e) => {
                if (u.hasClass(e.currentTarget, 'inactive')) {
                    return;
                }

                u.removeClass(finishButtons, 'is-active');

                activeFinish = parseInt(e.currentTarget.dataset.finish, 10);
                u.addClass(el.querySelector(`.pipeskirts__finish[data-finish="${activeFinish}"]`), 'is-active');

                updateInactiveOptions();
                activateOption();
            });
        }
    }
};
